module.exports = __webpack_public_path__ + "img/icon-bathroom.7140314e.svg";